export default __webpack_public_path__ + "static/media/PC.2cfbe939.png";